export const detectAdBlocker = async (): Promise<boolean> => {
  try {
    await fetch('https://js.stripe.com/v3/', {
      method: 'HEAD',
    });
    return false;
  } catch (error) {
    console.log('[AdBlockDetector] Stripe resources are blocked:', error);
    return true;
  }
};